import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CoreModule } from '@app-core/core.module';
import { I18nModule } from '@app-i18n/i18n.module';
import { PagesModule } from '@app-pages/pages.module';
import { AppComponent } from '@app/app.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CoreModule,
    PagesModule,
    I18nModule,
    RouterModule.forRoot([{ path: '**', redirectTo: '' }], { useHash: true, relativeLinkResolution: 'legacy' })
  ],
  bootstrap: [AppComponent],
  providers: []
})
export class AppModule {}
